<template lang="pug">
.mobile-actions
  RogueButton.country-select-v2(
    v-if="!$route.meta.isFunneled"
    @click="uiStore.showOverlay('country-select-v2', $rogue)"
    width="full"
    :left-icon="country.icon"
    right-icon="triangle"
    size="s"
  ) {{country.name}}
  .row.social
    rogue-link(
      target='_blank'
      :to='href'
      v-for='(href, key) in socialLinks'
      :aria-label=`key + ' (opens in a new tab)'`
      :key="href"
    )
      Icon( :name='key' fill='white' )
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getDisplayCountry } from '@/js/helpers/countries'
import { useRogue } from '@/js/services/Rogue'
import { useUIStore } from '@/js/stores/uiStore'

const rogue = useRogue()
const uiStore = useUIStore()

const country = computed(() => getDisplayCountry(rogue))

const DEFAULT_SOCIAL = {
  facebook  : 'https://www.facebook.com/roguefitness',
  youtube   : 'https://www.youtube.com/user/roguefitness/',
  instagram : 'https://instagram.com/roguefitness',
  twitter   : 'https://twitter.com/RogueFitness/',
  tiktok    : 'https://www.tiktok.com/@roguefitness',
}

const socialLinks = computed(() => rogue.site?.social || Object.assign({}, DEFAULT_SOCIAL))

</script>
<style lang="scss">
.mobile-actions .country-select-v2 {

  padding: 0 $space-s;
  height: 40px;

  .left.icon {
    width: 30px;
    height: 17px;
  }

  .slot {
    text-align: left;
  }
}
</style>
<style lang="scss" scoped>
.row.social {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: $space-s;
  margin-bottom: -$space-xxs;

  .row.social > a {
    font-size: $size-s;
    text-transform: uppercase;
    font: $font-condensed;
    font-weight: $weight-bold;
    text-decoration: none;
    color: white;
  }

  a {
    display: flex;
    align-items: center;
    text-transform: uppercase;
  }

  .icon {
    width: 50px;
    height: 50px;
    cursor: pointer;
    opacity: 1;

    &:hover {
      opacity: 0.8;
    }

  }
}
</style>
